import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { UserProvider } from '../../providers/user/user';


@IonicPage()
@Component({
  selector: 'page-users',
  templateUrl: 'users.html',
})
export class UsersPage {

  users;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public userProvider: UserProvider,
  ) {
    this.users = userProvider.getUsers();
  }

  addUser() {
    this.navCtrl.push('UserInfoPage', { mode: 'add' });
  }

  editUser(user) {
    this.navCtrl.push('UserInfoPage', { mode: 'edit', userId: user.key });
  }
  
  infoUser(user) {
    this.navCtrl.push('UserInfoPage', { mode: 'info', userId: user.key });
  }

  searchCancel(ev: any) {
    this.users = this.userProvider.getUsers();
  }
  
  searchItems(ev: any) {
    //this.users = this.userProvider.getUserNamesBySearch(ev.target.value, 'name')
  }
}


// WEBPACK FOOTER //
// ./src/pages/users/users.ts